import ExternalLink from 'components/UI/ExternalLink'
import InternalLink from 'components/UI/InternalLink'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import { platforms } from 'utils/platformList'

export default function DocumentationLinks({
  platformName,
}: {
  platformName: string
}): ReactElement {
  const documentationLinksQuery = useStaticQuery<Queries.DocumentationLinksQuery>(graphql`
    query DocumentationLinks {
      directus {
        download_page {
          strings {
            languages_code {
              code
            }
            source_code
            install_guide
            learn_more
          }
        }
      }
    }
  `)

  const documentationLinksData = getEnglishStrings(
    documentationLinksQuery.directus.download_page?.strings,
  )

  const learnMoreUrl = platforms[platformName].learnMoreUrl
  const installGuideUrl = platforms[platformName].installGuideUrl
  const sourceCodeUrl = platforms[platformName].sourceCodeUrl

  return (
    <Flex
      sx={{
        a: { textDecoration: 'underline' },
        gap: '1.6rem',
        width: '100%',
        justifyContent: ['center', 'flex-start', 'flex-start'],
        flexWrap: 'wrap',
      }}
    >
      {learnMoreUrl && (
        <>
          <InternalLink href={learnMoreUrl} sx={{ width: 'max-content' }}>
            {documentationLinksData?.learn_more}
          </InternalLink>
          <Text sx={{ color: 'white10' }}>•</Text>
        </>
      )}
      {installGuideUrl && (
        <InternalLink href={installGuideUrl} sx={{ width: 'max-content' }}>
          {documentationLinksData?.install_guide}
        </InternalLink>
      )}
      {sourceCodeUrl && (
        <>
          <Text sx={{ color: 'white10' }}>•</Text>
          <ExternalLink href={sourceCodeUrl} sx={{ width: 'max-content' }}>
            {documentationLinksData?.source_code}
          </ExternalLink>
        </>
      )}
    </Flex>
  )
}
